module.exports = __webpack_public_path__ + "static/assets/546af5edf2dcb58359ffa739340142b1.png";